import { render, staticRenderFns } from "./table-checked-counter.vue?vue&type=template&id=0d072864"
import script from "./table-checked-counter.vue?vue&type=script&lang=js"
export * from "./table-checked-counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports